import { useMemo, type ReactNode } from "react";

import { SharedSessionManageViewLayout } from "./SharedSessionManageViewLayout";

import type { SharedSession } from "@/queries/prompts";

export interface SharedSessionsManageViewProps {
  sessions: SharedSession[] | undefined;
  isLoadingSessions: boolean;
  onNewLink: () => void;
  renderSessionRow: (session: SharedSession, index: number) => ReactNode;
}

export const SharedSessionsManageView = ({
  sessions,
  isLoadingSessions,
  onNewLink,
  renderSessionRow,
}: SharedSessionsManageViewProps) => {
  const sessionRows = useMemo(
    () => sessions?.map((session, index) => renderSessionRow(session, index)) ?? null,
    [sessions, renderSessionRow],
  );

  return (
    <SharedSessionManageViewLayout
      sessions={sessions}
      isLoadingSessions={isLoadingSessions}
      onNewLink={onNewLink}
      sessionRows={sessionRows}
    />
  );
};
